'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderAnnouncementCarousel = function HeaderAnnouncementCarousel(el) {
  (0, _classCallCheck3.default)(this, HeaderAnnouncementCarousel);

  var carousel = (0, _functional.getElement)('[data-module="header-announcement-carousel"]');
  var flkty = new _flickity2.default(carousel, {
    cellAlign: 'center',
    cellSelector: '.hd-AnnouncementBar_Item',
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    touchVerticalScroll: false,
    autoPlay: true,
    dragThreshold: 30,
    watchCSS: true
  });

  flkty.on('dragStart.el', function (event, pointer) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });

  flkty.on('dragEnd.flickity', function (event, pointer) {
    document.ontouchmove = function (e) {
      return true;
    };
  });
};

exports.default = HeaderAnnouncementCarousel;